import { defineMessages } from 'react-intl';

export const notificationMessages = defineMessages({
  notifications: {
    defaultMessage: 'Notifications',
    description: `Button to show the user their notifications`,
    id: 'uchi.notificationsbutton.label',
  },
});
